<template>
  <div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>
              relacionado<br />
              com agenda
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(role, key) in roles" :key="key">
            <td>{{ role.name }}</td>
            <td @click.prevent="relateRole(role)">
              <switches
                v-model="role.related"
                theme="bootstrap"
                color="success"
                :emit-on-mount="false"
              ></switches>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Switches from 'vue-switches';
export default {
  components: { Switches },
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      roles: [],
    };
  },

  mounted() {
    this.listRoles();
  },
  methods: {
    async listRoles() {
      const list = await this.$store.dispatch('ROLES/ListRoles');
      const rolesMapped = list.map(i => ({
        id: i.id,
        name: i.name,
        related: i.tariffSchedule && i.tariffSchedule === this.selectedSchedule,
      }));
      this.roles = rolesMapped;
    },
    async relateRole(role) {
      const roleStateBefore = role.related;
      try {
        const roleStateToggle = !role.related;
        role.related = roleStateToggle;
        await this.$store.dispatch('RELATE/RelateRole', {
          tariffScheduleId: this.selectedSchedule,
          roleId: role.id,
          state: roleStateToggle,
        });
        this.$toasted.success('Permissão relacionado com sucesso!');
      } catch (error) {
        role.related = roleStateBefore;
        this.$toasted.error('Não foi possível relacionar usuário');
      }
    },
  },
};
</script>
